import React, { useState } from 'react'
import { StyledUserLoginForm } from './styles'
import { Input } from '../../../ui/Input/Input'
import { setNickname } from '../../../slices/main/mainSlice';
import { useParams } from 'react-router-dom';
import { TMusicMafiaURL } from '../../../utils/types';
import { joinRoom } from '../../../slices/main/mainThunk';
import { useAppDispatch } from '../../../slices/store';
import { Button } from '../../../ui/Button/Button';
import { useTranslation } from 'react-i18next';

export const UserLoginForm = () => {
  const { roomId } = useParams<TMusicMafiaURL>();

  const [userName, setUserName] = useState('');
  const [inputError, setInputError] = useState('');

  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const handleClick = async () => {
    if (userName && roomId) {
      await dispatch(joinRoom({room_id: roomId, user_name: userName}));
      dispatch(setNickname(userName));
    } else {
      setInputError('*nickname is required');
    }
  }

  const handleInputChange = (value: string) => {
    if (inputError) {
      setInputError('');
    }
    setUserName(value);
  }

  return (
    <StyledUserLoginForm>
      <Input className='input' value={userName} onEnter={handleClick} onChange={handleInputChange} placeholder={t('music_mafia.login.placeholder')} error={inputError} invalid={!!inputError} />
      <Button className='button' disabled={!userName} title={t('music_mafia.login.join_room')} handleClick={handleClick} />
    </StyledUserLoginForm>
  )
}
